import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/batch/work-orders',
    name: 'POST_PRODUCTION_ORDERS',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
